<h1 class="form-title form-title__bp_lt-md_center">
  {{ 'login.form.title' | translate }}
</h1>

<form [formGroup]="form" (submit)="onSubmit()" novalidate>
  <app-custom-input-text
    label="login.form.email"
    placeholder="login.form.email"
    key="email"
    type="text"
    [control]="form.get('email')"
    [submitted]="this.isSubmited"
    [errorsList]="errorFeedbackList.email">
  </app-custom-input-text>

  <app-custom-input-password
    key="password"
    [control]="form.get('password')"
    [submitted]="this.isSubmited"
    [errorsList]="errorFeedbackList.password">
  </app-custom-input-password>

  <app-button
    *ngIf="isShowSubmitButton"
    class="ind-btn-wrapper-100"
    type="submit"
    label="buttons.labels.go"
    [className]="'ind-btn--primary'"></app-button>

  <app-account-not-verified
    *ngIf="isNotVerifiedEmail"
    class="custom-button-wrapper"
    (completeVerification)="onCompleteVerification()">
  </app-account-not-verified>

  <div class="link-wapper">
    <a class="link capitalize" [routerLink]="rememberPath">{{
      'login.dont-remember-password' | translate
    }}</a>
  </div>

  <div class="ind-wrapper-form-mobile">
    <div class="ind-triangle-bg">
      <h2 class="form-subtitle-text">
        {{ 'login.welcome.footer.title' | translate }}
      </h2>
      <app-button
        class="ind-btn-wrapper-100"
        [routerLink]="registerPath"
        label="buttons.labels.create-account"
        [className]="screenSize === 'Mobile' ? 'ind-btn--secondary' : 'ind-btn--primary'">
      </app-button>
    </div>
  </div>
</form>
